import {
  SET_APP_VERSION_DATA,
  SET_APP_SUPPORT_ENDING_DIALOG_SEEN,
} from '../reducers/appVersionData';

export const acSetAppVersionData = (status) => ({
  type: SET_APP_VERSION_DATA,
  payload: status,
});

export const acSetAppSupportEndingDialogSeen = (value) => ({
  type: SET_APP_SUPPORT_ENDING_DIALOG_SEEN,
  payload: value,
});
